// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Set', {toJSON: require('./$.collection-to-json')('Set')});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es7.set.to-json.js
// module id = 182
// module chunks = 0